'use client';

import Link from 'next/link';
import './styles/default.scss';
import { getPlatformBridge } from '@/logic/bridges';
import { classes } from '@/utils/classes/classes';

type RegulatoryLogosProps = {
    isMobile: boolean;
    isXsell: boolean;
    isAndroid: boolean;
    legal?: {
        selfExclusionLogoUrl?: string;
        selfExclusionUrl?: {
            url?: string;
            target?: string;
        };
        stateGcbLogoUrl?: string;
        stateGcbUrl?: {
            url?: string;
            target?: string;
        };
    };
};

export const RegulatoryLogos = ({ isMobile, isXsell, isAndroid, legal }: RegulatoryLogosProps) => {
    const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>, url?: string) => {
        if (!url || (!isXsell && !isAndroid)) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        const bridge = getPlatformBridge();
        bridge.exec('openExternalWebView', url);
        bridge.exec('redirectToBrowser', url);
    };

    return (
        <div className="regulatory-logos">
            {legal?.selfExclusionLogoUrl && legal?.selfExclusionUrl?.url && legal?.selfExclusionUrl?.target && (
                <Link
                    href={legal?.selfExclusionUrl?.url}
                    target={legal?.selfExclusionUrl?.target}
                    rel="external"
                    className="regulatory-logos__self-exclusion-logo-link"
                    onClick={(e) => handleLogoClick(e, legal?.selfExclusionUrl?.url)}>
                    <img src={legal?.selfExclusionLogoUrl} alt="self-exclusion" height={30} width="auto" />
                </Link>
            )}
            {!isMobile && <div className="regulatory-logos__regulatory-logo-divider" />}
            {legal?.stateGcbLogoUrl && legal?.stateGcbUrl?.url && legal?.stateGcbUrl?.target && (
                <div
                    className={classes(
                        'regulatory-logos__state-gcb-logo-wrapper',
                        isMobile && 'regulatory-logos__spacing-left'
                    )}>
                    <Link
                        href={legal?.stateGcbUrl?.url}
                        target={legal?.stateGcbUrl?.target}
                        rel="external"
                        className="regulatory-logos__state-gcb-logo-link"
                        onClick={(e) => handleLogoClick(e, legal?.stateGcbUrl?.url)}>
                        <img src={legal?.stateGcbLogoUrl} alt="gcb" height={30} width="auto" />
                    </Link>
                </div>
            )}
        </div>
    );
};
